import { render } from "./lesson-plan.vue?vue&type=template&id=51ebe8b4&scoped=true&ts=true"
import script from "./lesson-plan.ts?vue&type=script&lang=ts&external"
export * from "./lesson-plan.ts?vue&type=script&lang=ts&external"

import "./lesson-plan.vue?vue&type=style&index=0&id=51ebe8b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ebe8b4"]])

export default __exports__